module.exports = __webpack_public_path__ + "static/media/star.76f3337f.svg";